import {
  REVEAL_FAST_TIME_MS,
  REVEAL_SLOW_TIME_MS,
} from './../constants/settings'

import { REVEAL_SPEED_FAST } from './../constants/strings'

// Stable time independent of the system clock
// For validating subscriptions.
export const getTrueTime = async () => {
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
  try {
    const resp = await fetch('https://worldtimeapi.org/api/timezone/' + tz)
    const data = await resp.json()
    return new Date(data.datetime)
  } catch {
    return new Date()
  }
}

export const isAprilFools = () => {
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  const aprilFools = new Date('2023-04-01T00:00:00')
  aprilFools.setHours(0, 0, 0, 0)
  return today.getTime() === aprilFools.getTime()
}

export const getRevealTime = (revealSpeed: string) => {
  return revealSpeed === REVEAL_SPEED_FAST
    ? REVEAL_FAST_TIME_MS
    : REVEAL_SLOW_TIME_MS
}
